<div>
    {{#if errors.filter}}
    <div class="alert alert-danger">{{TR errors.filter}}</div>
    {{/if}}
    <div class="row">
        <div class="col-xs-12 co-sm-12 col-md-12 col-lg-4">
            <div class="form-group">
                <label for="df-search-text" class="js-same-height control-label">{{TR "Suche"}}</label>
                <div class="input-group">
                    <input
                        type="text"
                        class="form-control input-sm js-filter-edit"
                        id="df-search-text"
                        placeholder="{{TR "Gerätesuche (Name, Adresse, Meta-Daten)"}}"
                        value="{{inputData.search_text}}"
                    >
                    <span class="input-group-btn">
                        <button type="button" class="btn btn-sm btn-default js-df-search"><i class="fa fa-search"></i></button>
                    </span>
                </div>
            </div>
        </div>

        <div class="col-xs-12 col-sm-6 col-md-3 col-lg-2">
            <div class="form-group">
                <label for="df-categories" class="js-same-height control-label">{{TR "Gerätekategorie"}}</label>
                {{#SELECT inputData.category}}
                <select class="selectpicker js-filter-multiselect" multiple="multiple" data-style="btn-white btn-sm {{#if fixedCategory}}disabled{{/if}}" id="df-categories">
                    {{#each categories}}
                    <option data-icon="{{icon}}" value="{{value}}">{{name}}</option>
                    {{/each}}
                </select>
                {{/SELECT}}
            </div>
        </div>


        <div class="col-xs-12 col-sm-6 col-md-3 col-lg-2">
            <div class="form-group">
                <label for="df-labels" class="js-same-height control-label">{{TR "Labels"}}</label>
                {{#SELECT inputData.labels}}
                <select class="selectpicker js-filter-multiselect" data-can-exclude="true" multiple="multiple" data-style="btn-white btn-sm" id="df-labels" name="df_labels">
                    {{#if tags}}
                    <optgroup label="{{TR "Öffentlich"}}">
                        {{#each tags}}
                        <option value="t_{{this}}">{{this}}</option>
                        {{/each}}
                    </optgroup>
                    {{/if}}
                    <optgroup label="{{TR "Privat"}}">
                        {{#each groups}}
                        <option value="g_{{this}}">{{this}}</option>
                        {{/each}}
                    </optgroup>
                </select>
                {{/SELECT}}
            </div>
        </div>

        <div class="col-xs-12 col-sm-6 col-md-3 col-lg-2">
            <div class="form-group">
                <label for="df-groups" class="js-same-height control-label">{{TR "Gerätegruppen"}}</label>
                {{#SELECT inputData.groups}}
                <select class="selectpicker js-filter-multiselect" data-can-exclude="true" multiple="multiple" data-style="btn-white btn-sm" id="df-groups" name="df_groups">
                    {{#each deviceGroups}}
                    <option value="d_{{id}}">{{name}}</option>
                    {{/each}}
                </select>
                {{/SELECT}}
            </div>
        </div>

        {{#IF_AVAILABLE 'status'}}
        <div class="col-xs-12 col-sm-6 col-md-3 col-lg-2">
            <div class="form-group">
                <label for="df-status" class="js-same-height control-label">{{TR "Status"}}</label>
                {{#SELECT inputData.status}}
                <select class="selectpicker js-filter-multiselect {{#if fixedStatus}}disabled{{/if}}" multiple="multiple" data-style="btn-white btn-sm" id="df-status" name="df_status">
                    <option data-icon="fa fa-circle success" value="ok">{{TR "funktioniert"}}</option>
                    <option data-icon="fa fa-circle error"   value="delayed">{{TR "nicht gemeldet"}}</option>
                    <option data-icon="fa fa-circle warning" value="error">{{TR "fehlerhaft"}}</option>
                    <option data-icon="fa fa-circle deactivated" value="deactivated">{{TR "inaktiv"}}</option>
                    <option data-icon="fa fa-circle archived" value="archived">{{TR "archiviert"}}</option>
                </select>
                {{/SELECT}}
            </div>
        </div>
        {{/IF_AVAILABLE}}
    </div>

    {{#if errors.type}}
    <div class="alert alert-danger">{{TR errors.type}}</div>
    {{/if}}

    <div class="row">
        <div class="col-xs-12">
            <div class="form-group" id="df-conditions">
                <label for="name" class="control-label">{{TR "Bedingung"}}</label>
                {{#each inputData.conditions}}
                <div class="row m-t-5 js-df-cond-row" data-row="{{row}}">
                    <div class="col-xs-12 col-sm-4">
                        {{#SELECT field}}
                        <select class="selectpicker js-df-field" data-style="btn-white btn-sm">
                            {{#each ../fieldSet}}
                            <optgroup label="{{name}}">
                                {{#each items}}
                                <option value="{{id}}">{{TR name}}</option>
                                {{/each}}
                            </optgroup>
                            {{/each}}
                        </select>
                        {{/SELECT}}
                    </div>
                    <div class="col-xs-12 col-sm-2">
                        {{#SELECT op}}
                        <select class="selectpicker js-df-op js-filter-select" data-style="btn-white btn-sm">
                        {{#each comparison}}
                            <option value="{{k}}">{{o}}</option>
                            {{/each}}
                        </select>
                        {{/SELECT}}
                    </div>
                    <div class="col-xs-12 col-sm-5 col-lg-4">
                        {{#if isFixedDate}}
                            <div class="row">
                                <div class="col-xs-12 col-sm-6">
                                    <div class="input-group date">
                                        <input type="text" class="input-sm form-control js-df-value-date js-datepicker" value="{{valueDate}}">
                                        </input>
                                        <span class="input-group-addon b-0 btn-white">
                                            <i class="fa fa-calendar"></i>
                                        </span>
                                    </div>
                                </div>
                                <div class="col-xs-12 col-sm-6">
                                    <div class="input-group bootstrap-timepicker timepicker">
                                        <input type="text" class="form-control input-sm js-df-value-time js-timepicker" value="{{valueTime}}">
                                        <span class="input-group-addon b-0 btn-white">
                                            <i class="fa fa-clock-o"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        {{/if}}
                        {{#if isFieldStatus}}
                            <div class="row">
                                <div class="col-xs-12 col-sm-12">
                                    {{#SELECT value}}
                                    <select class="selectpicker js-value-status" multiple="multiple" data-style="btn-white btn-sm">
                                        {{#each ../statusBits}}
                                        <optgroup label="{{categoryName}}">
                                            {{#each bits}}
                                            <option value="{{value}}">{{text}}</option>
                                            {{/each}}
                                        </optgroup>
                                        {{/each}}
                                    </select>
                                    {{/SELECT}}
                                </div>
                            </div>
                        {{/if}}
                        {{#if isFieldData}}
                            <div class="row">
                                <div class="col-xs-12 col-sm-6">
                                    <select class="selectpicker js-df-field2-type js-filter-select" data-style="btn-white btn-sm">
                                        <option value="f" {{#unless isFieldDataRef}}selected{{/unless}}>{{TR 'Fester Wert'}}</option>
                                        <option
                                            value="v"
                                            {{#if isFieldDataRef}}selected{{/if}}
                                        >{{TR 'Wert vom Gerät'}}</option>
                                    </select>
                                </div>

                                <div class="col-xs-12 col-sm-6">
                                    {{#if isFieldDataRef}}
                                        {{#SELECT value}}
                                        <select class="selectpicker js-df-field2 js-filter-select" data-style="btn-white btn-sm">
                                            {{#each ../dataCols}}
                                            <option value="{{id}}">{{name}}</option>
                                            {{/each}}
                                        </select>
                                        {{/SELECT}}
                                    {{else}}
                                        {{#if isFieldDataTypeEnum}}
                                        <div class="input-group">
                                            {{#SELECT value}}
                                            <select class="selectpicker js-df-field2-enum js-filter-select" data-style="btn-white btn-sm">
                                                {{#each fieldDataEnumItems}}
                                                <option value="{{value}}">{{text}}</option>
                                                {{/each}}
                                            </select>
                                            {{/SELECT}}
                                        </div>
                                        {{else}}
                                        <div class="input-group">
                                            <input type="text" class="form-control input-sm js-df-field2-fixed js-filter-edit" value="{{value}}">
                                            <span class="input-group-addon b-0">
                                                {{valueUnit}}
                                            </span>
                                        </div>
                                        {{/if}}
                                    {{/if}}
                                </div>
                            </div>
                        {{/if}}
                        {{#if isFixedText}}
                            {{#if isFixedTextSelect}}
                            {{#SELECT value}}
                            <select class="selectpicker js-df-field-text-select js-filter-select {{#if useMultiSelect}} js-filter-multiselect {{/if}}" data-can-exclude="false" {{#if useMultiSelect}} multiple="multiple" {{/if}} data-style="btn-white btn-sm">
                                {{#each fieldTextSelectOptions}}
                                <option value="{{this}}">{{this}}</option>
                                {{/each}}
                                {{#if useMultiSelect}} <option value="__empty__"> ({{TR 'Leer'}}) </option> {{/if}}
                            </select>
                            {{/SELECT}}
                            {{else}}
                            <input type="text" class="form-control input-sm js-df-field-text-fixed js-filter-edit" value="{{value}}">
                            {{/if}}
                        {{/if}}
                    </div>
                    <div class="col-xs-12 col-sm-1 col-lg-2">
                        <button class="btn btn-white btn-sm pull-right js-df-cond-delete">
                            <i class="fa fa-trash"></i>
                        </button>
                    </div>
                </div>
                {{/each}}
                <div class="row m-t-5">
                    <div class="col-xs-12">
                        <button class="btn btn-white btn-sm" id="df-cond-add"><i class="fa fa-plus"></i></button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    {{#if showDeviceCount}}
    <div class="row">
        <div class="col-xs-12">
            <div class="alert alert-success m-t-15">
                {{TR 'Anzahl der aktuell ausgewählten Geräte'}}: <strong id="ct-device-count">{{deviceCount}}</strong>
            </div>
        </div>
    </div>
    {{/if}}
</div>
